import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import SignIn from '@/views/SignIn'
import Admin from '@/views/Admin'
import EditEvent from '@/views/EditEvent'
import EditUpdate from '@/views/EditUpdate'
import { store } from '@/store'
import { firebase } from '@/firebase'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/termsandconditions',
      name: 'termsandconditions',
      component: () => import('./views/TermsAndConditions.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/Privacy.vue')
    },
    {
      path: '/signin',
      name: 'signin',
      component: SignIn
    },
    {
      path: '/admin',
      name: 'signin',
      component: Admin
    },
    {
      path: '/edit-event/:eventId',
      name: 'edit-event',
      component: EditEvent,
      props: true
    },
    {
      path: '/edit-event/',
      name: 'edit-event',
      component: EditEvent,
      props: true
    },
    {
      path: '/edit-update/:updateId',
      name: 'edit-update',
      component: EditUpdate,
      props: true
    },
    {
      path: '/edit-update/',
      name: 'edit-update',
      component: EditUpdate,
      props: true
    },
  ]
})

var getUser = function () {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user) => {
      //console.log("getUser: Waiting for user", user)
      if (user) {
        store.dispatch('updateUser', user)
        resolve(user)
      } else {
        reject("User Not Available")
      }
    })
  })
}
/**
 * Redirect to the sign in page if user is not logged in
 */
router.beforeEach(async function (to, from, next) {
  // check if going to signin page and call next() to proceed
  try {
    let user = await getUser();
    console.log("Found user", user.email)
    next()
  } catch (error) {
    console.log(error)
    next()
  }

  // if (to.name === 'signin') {
  //   console.log("ROUTER: going to signin")
  //   next()
  // }
  // else {
  //   try {
  //     console.log("ROUTER:", new Date(), "getting user")
  //     let user = await getUser();
  //     console.log("ROUTER:", new Date(), "got user")
  //     // check if the user is logged in
  //     console.log("ROUTER: user is logged in", user)
  //     console.log("ROUTER: going to requested page", to.name)
  //     next()
  //   } catch (error) {
  //     console.log("ROUTER: Error:", error)
  //     console.log("ROUTER: going to signin")
  //     next({ name: 'signin' })
  //   }
  // }
})

export default router